import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(() => ({
    title: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 32px',
    },
    titleText: {
        margin: 0,
        fontSize: '1.75rem',
        fontWeight: 500,
    },
    content: {
        padding: '24px 32px 32px',
    },
    contentRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 24,
    },
    kangarooImage: {
        width: 100,
        height: 'auto',
        flexShrink: 0,
    },
    contentText: {
        marginBottom: 0,
        fontSize: '19px',
        lineHeight: 1.6,
    },
}));

const MaintenanceDialog = ({open, onClose}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="maintenance-dialog-title"
            aria-describedby="maintenance-dialog-description"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle
                id="maintenance-dialog-title"
                disableTypography
                className={classes.title}
            >
                <h2 className={classes.titleText}>
                    {t('maintenance_title')}
                </h2>
                <IconButton
                    aria-label={t('Close')}
                    onClick={onClose}
                    style={{marginLeft: 8}}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers className={classes.content}>
                <div className={classes.contentRow}>
                    <img
                        src="/main_kangaroo.png"
                        alt=""
                        className={classes.kangarooImage}
                    />
                    <DialogContentText
                        id="maintenance-dialog-description"
                        className={classes.contentText}
                    >
                        {t('maintenance_message')}
                    </DialogContentText>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default MaintenanceDialog;
